import { render, staticRenderFns } from "./WatchOutForScams.vue?vue&type=template&id=2fd0fb14&"
import script from "./WatchOutForScams.vue?vue&type=script&lang=js&"
export * from "./WatchOutForScams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports